
<div class="container p-3">
  @if (!selectedReportType) {
    <div>
      <h3 class="mb-3">{{'fieldReporting.singleOrderDetail.selectReportType' | translate}}</h3>
      @for (status of statuses; track $index) {
        <div
          class="d-flex justify-content-between align-items-center py-3 border-bottom hover-bg-light cursor-pointer"
          [class.highlight-status]="status?.id == highlightStatusId"
          (click)="changeReportType(status)"
          >
          <div class="fw-semibold">
            @if (status?.id) {
              @if (reportsStateMap.get(status.id)) {
                <!-- Check if status is read-only (reported by another team) -->
                @if (isStatusReadOnly(status)) {
                  <img src="assets/icons/visibility_gray_24dp.svg" class="pe-1" alt="read only" />
                  <!-- Show checkmark for normal reports (report_type = 1) by other teams -->
                  @if (reportsStateMap.get(status.id) === 1) {
                    <img src="assets/icons/check_green_24dp.svg" class="pe-1" alt="done by other team" />
                  }
                  <!-- Show X for interrupted reports (report_type = 2) by other teams -->
                  @if (reportsStateMap.get(status.id) === 2) {
                    <img src="assets/icons/close_red_24dp.svg" class="pe-1" alt="interrupted by other team" />
                  }
                  <span class="text-secondary">{{ status?.name }}</span>
                } @else {
                  <!-- Normal report (report_type = 1) -->
                  @if (reportsStateMap.get(status.id) === 1) {
                    <img src="assets/icons/check_green_24dp.svg" alt="done" />
                  }
                  <!-- Interrupted report (report_type = 2) -->
                  @if (reportsStateMap.get(status.id) === 2) {
                    <img src="assets/icons/close_red_24dp.svg" alt="interrupted" />
                  }
                  <span [ngClass]="{'text-danger': reportsStateMap.get(status.id) === 2}">{{ status?.name }}</span>
                }
              } @else {
                @if (!canBeReported(status)) {
                  <img src="assets/icons/visibility_gray_24dp.svg" class="pe-1" alt="read only" />
                  <span class="text-secondary">{{ status?.name }}</span>
                } @else {
                  {{ status?.name }}
                }
              }
            }
          </div>
          <img src="assets/icons/chevron_right_gray_24dp.svg" alt="" />
        </div>
      }
      <button class="btn btn-primary mt-2 w-100" (click)="backToDashboard()">{{'planner.reportWorkorderDetail.backToDashboard' | translate}}</button>
    </div>
  }

  @if (selectedReportType) {
    <div>
      <div class="d-flex align-items-center border-bottom pb-3 mb-3">
        <img
          src="assets/icons/chevron_left_gray_24dp.svg"
          alt="Back arrow"
          style="width: 24px; height: 24px; cursor: pointer;"
          (click)="backToList()"
          />
        <h4 class="ms-3 mb-0">{{identifier}}</h4>
      </div>
      <div class="mb-3" ngbDropdown>
        <div
          id="dropdownReportType"
          ngbDropdownToggle
          class="blue-text cursor-pointer w-100"
          >
          <span class="me-2">{{ selectedReportType.name }}</span>
        </div>
        <div ngbDropdownMenu aria-labelledby="dropdownReportType">
          @for (status of statuses; track $index) {
            <button
              class="dropdown-item"
              (click)="changeReportType(status)"
              [class.highlight-status]="status?.id == highlightStatusId"
              >
              {{ status?.name }}
            </button>
          }
        </div>
      </div>
      <hr>
        @if (selectedReportType.state === 1) {
          <fieldset
            [disabled]="!canBeReported(selectedReportType)">
            <h5 class="mb-3">{{'fieldReporting.report.installationDone' | translate}}</h5>
            <div class="d-flex justify-content-start mb-4">
              <button class="btn me-3" style="width: 100px;" (click)="installationDone = true" [ngClass]="installationDone ? 'btn-primary' : 'btn-outline-primary'">{{'basic.yes' | translate}}</button>
              <button class="btn" style="width: 100px;" (click)="installationDone = false" [ngClass]="installationDone ? 'btn-outline-danger' : 'btn-danger'">{{'basic.no' | translate}}</button>
            </div>
            <hr />
            <h5 class="mb-2">{{'basic.comment' | translate}}</h5>
            <textarea
              rows="3"
              class="form-control mb-4"
              [(ngModel)]="comment"
            ></textarea>
            <!--<div
            class="d-flex align-items-center mb-4"
            style="cursor: pointer;"
            (click)="imgInput.click()"
            >
            <img
              src="assets/icons/kamera_blue.svg"
              alt="Camera icon"
              style="width: 32px; height: auto; margin-right: 12px;"
              />
            <p class="mb-0">
              Click the icon to take a picture
            </p>
            <input
              #imgInput
              type="file"
              accept="image/*"
              (change)="handleImageUpload($event)"
              style="display: none;"
              />
          </div>
          <div class="d-flex flex-wrap">
            <div *ngFor="let image of images">
              <img class="thumbnail-img" [src]="image.img" height="50" (click)="this.currentImg = image; openInModal(content)">
            </div>
          </div>-->
          @if (!isStatusReadOnly(selectedReportType)) {
            <app-image-selector (imageSelected)="handleImageUpload($event)"></app-image-selector>
          }
          <div class="d-flex flex-wrap">
            @for (image of images; track $index) {
              <div>
                <img class="thumbnail-img p-1" [src]="image.img" height="100" width="100"
                  (click)="this.currentImg = image; openInModal(content)">
              </div>
            }
          </div>
          @if (!isStatusReadOnly(selectedReportType)) {
            <button class="btn btn-primary w-100" (click)="saveReport()">{{'basic.save' | translate}}</button>
          }
        </fieldset>
      }
      @if (selectedReportType.state === 2) {
        <fieldset
          [disabled]="!canBeReported(selectedReportType)">
          <h5 class="mb-3">{{'fieldReporting.report.installationDone' | translate}}</h5>
          <div class="d-flex justify-content-start mb-4">
            <button class="btn me-3" style="width: 100px;" (click)="installationDone = true" [ngClass]="installationDone ? 'btn-primary' : 'btn-outline-primary'">{{'basic.yes' | translate}}</button>
            <button class="btn" style="width: 100px;" (click)="installationDone = false" [ngClass]="installationDone ? 'btn-outline-danger' : 'btn-danger'">{{'basic.no' | translate}}</button>
          </div>
          <hr />
          <h5 class="mb-2">{{'basic.comment' | translate}}</h5>
          <textarea
            rows="3"
            class="form-control mb-4"
            [(ngModel)]="comment"
          ></textarea>
          @if (!isStatusReadOnly(selectedReportType)) {
            <app-image-selector (imageSelected)="handleImageUpload($event)"></app-image-selector>
          }
          <div class="d-flex flex-wrap">
            @for (image of images; track $index) {
              <div>
                <img class="thumbnail-img p-1" [src]="image.img" height="100" width="100"
                  (click)="this.currentImg = image; openInModal(content)">
              </div>
            }
          </div>
          @if (!isStatusReadOnly(selectedReportType)) {
            <button class="btn btn-primary w-100" (click)="saveReport()">{{'basic.save' | translate}}</button>
          }
        </fieldset>
      }
      @if (selectedReportType.state === 3) {
        <fieldset [disabled]="!canBeReported(selectedReportType)">
          <h5 class="mb-3">{{'fieldReporting.report.installationDone' | translate}}</h5>
          <div class="d-flex justify-content-start mb-4">
            <button class="btn me-3" style="width: 100px;" (click)="installationDone = true" [ngClass]="installationDone ? 'btn-primary' : 'btn-outline-primary'">{{'basic.yes' | translate}}</button>
            <button class="btn" style="width: 100px;" (click)="installationDone = false" [ngClass]="installationDone ? 'btn-outline-danger' : 'btn-danger'">{{'basic.no' | translate}}</button>
          </div>
          <hr />
          <h5 class="mb-2">{{'basic.comment' | translate}}</h5>
          <textarea
            rows="3"
            class="form-control mb-4"
            [(ngModel)]="comment"
          ></textarea>
          @if (!isStatusReadOnly(selectedReportType)) {
            <app-image-selector (imageSelected)="handleImageUpload($event)"></app-image-selector>
          }
          <div class="d-flex flex-wrap">
            @for (image of images; track $index) {
              <div>
                <img class="thumbnail-img p-1" [src]="image.img" height="100" width="100"
                  (click)="this.currentImg = image; openInModal(content)">
              </div>
            }
          </div>
          @if (!isStatusReadOnly(selectedReportType)) {
            <button class="btn btn-primary w-100" (click)="saveReport()">{{'basic.save' | translate}}</button>
          }
        </fieldset>
      }
      @if (selectedReportType.state === 4) {
        <fieldset [disabled]="!canBeReported(selectedReportType)">
          <h5 class="mb-3">{{'fieldReporting.report.installationDone' | translate}}</h5>
          <div class="d-flex justify-content-start mb-4">
            <button class="btn me-3" style="width: 100px;" (click)="installationDone = true" [ngClass]="installationDone ? 'btn-primary' : 'btn-outline-primary'">{{'basic.yes' | translate}}</button>
            <button class="btn" style="width: 100px;" (click)="installationDone = false" [ngClass]="installationDone ? 'btn-outline-danger' : 'btn-danger'">{{'basic.no' | translate}}</button>
          </div>
          <hr />
          <h5 class="mb-2">{{'basic.comment' | translate}}</h5>
          <textarea
            rows="3"
            class="form-control mb-4"
            [(ngModel)]="comment"
          ></textarea>
          @if (!isStatusReadOnly(selectedReportType)) {
            <app-image-selector (imageSelected)="handleImageUpload($event)"></app-image-selector>
          }
          <div class="d-flex flex-wrap">
            @for (image of images; track $index) {
              <div>
                <img class="thumbnail-img p-1" [src]="image.img" height="100" width="100"
                  (click)="this.currentImg = image; openInModal(content)">
              </div>
            }
          </div>
          @if (!isStatusReadOnly(selectedReportType)) {
            <button class="btn btn-primary w-100" (click)="saveReport()">{{'basic.save' | translate}}</button>
          }
        </fieldset>
      }
      @if (selectedReportType.state === 5) {
        <fieldset [disabled]="!canBeReported(selectedReportType)">
          <h5 class="mb-3">{{'fieldReporting.report.installationDone' | translate}}</h5>
          <div class="d-flex justify-content-start mb-4">
            <button class="btn me-3" style="width: 100px;" (click)="installationDone = true" [ngClass]="installationDone ? 'btn-primary' : 'btn-outline-primary'">{{'basic.yes' | translate}}</button>
            <button class="btn" style="width: 100px;" (click)="installationDone = false" [ngClass]="installationDone ? 'btn-outline-danger' : 'btn-danger'">{{'basic.no' | translate}}</button>
          </div>
          <hr />
          <h5 class="mb-2">{{'basic.comment' | translate}}</h5>
          <textarea
            rows="3"
            class="form-control mb-4"
            [(ngModel)]="comment"
          ></textarea>
          @if (!isStatusReadOnly(selectedReportType)) {
            <app-image-selector (imageSelected)="handleImageUpload($event)"></app-image-selector>
          }
          <div class="d-flex flex-wrap">
            @for (image of images; track $index) {
              <div>
                <img class="thumbnail-img p-1" [src]="image.img" height="100" width="100"
                  (click)="this.currentImg = image; openInModal(content)">
              </div>
            }
          </div>
          @if (!isStatusReadOnly(selectedReportType)) {
            <button class="btn btn-primary w-100" (click)="saveReport()">{{'basic.save' | translate}}</button>
          }
        </fieldset>
      }
      @if (selectedReportType.state === 6) {
        <fieldset [disabled]="!canBeReported(selectedReportType)">
          <h5 class="mb-3">{{'fieldReporting.report.installationDone' | translate}}</h5>
          <div class="d-flex justify-content-start mb-4">
            <button class="btn me-3" style="width: 100px;" (click)="installationDone = true" [ngClass]="installationDone ? 'btn-primary' : 'btn-outline-primary'">{{'basic.yes' | translate}}</button>
            <button class="btn" style="width: 100px;" (click)="installationDone = false" [ngClass]="installationDone ? 'btn-outline-danger' : 'btn-danger'">{{'basic.no' | translate}}</button>
          </div>
          <hr />
          <h5 class="mb-2">{{'basic.comment' | translate}}</h5>
          <textarea
            rows="3"
            class="form-control mb-4"
            [(ngModel)]="comment"
          ></textarea>
          @if (!isStatusReadOnly(selectedReportType)) {
            <app-image-selector (imageSelected)="handleImageUpload($event)"></app-image-selector>
          }
          <div class="d-flex flex-wrap">
            @for (image of images; track $index) {
              <div>
                <img class="thumbnail-img p-1" [src]="image.img" height="100" width="100"
                  (click)="this.currentImg = image; openInModal(content)">
              </div>
            }
          </div>
          @if (!isStatusReadOnly(selectedReportType)) {
            <button class="btn btn-primary w-100" (click)="saveReport()">{{'basic.save' | translate}}</button>
          }
        </fieldset>
      }
      @if (selectedReportType.state === 7) {
        <fieldset [disabled]="!canBeReported(selectedReportType)">
          <h5 class="mb-3">{{'fieldReporting.report.installationDone' | translate}}</h5>
          <div class="d-flex justify-content-start mb-4">
            <button class="btn me-3" style="width: 100px;" (click)="installationDone = true" [ngClass]="installationDone ? 'btn-primary' : 'btn-outline-primary'">{{'basic.yes' | translate}}</button>
            <button class="btn" style="width: 100px;" (click)="installationDone = false" [ngClass]="installationDone ? 'btn-outline-danger' : 'btn-danger'">{{'basic.no' | translate}}</button>
          </div>
          <hr />
          <h5 class="mb-2">{{'basic.comment' | translate}}</h5>
          <textarea
            rows="3"
            class="form-control mb-4"
            [(ngModel)]="comment"
          ></textarea>
          @if (!isStatusReadOnly(selectedReportType)) {
            <app-image-selector (imageSelected)="handleImageUpload($event)"></app-image-selector>
          }
          <div class="d-flex flex-wrap">
            @for (image of images; track $index) {
              <div>
                <img class="thumbnail-img p-1" [src]="image.img" height="100" width="100"
                  (click)="this.currentImg = image; openInModal(content)">
              </div>
            }
          </div>
          @if (!isStatusReadOnly(selectedReportType)) {
            <button class="btn btn-primary w-100" (click)="saveReport()">{{'basic.save' | translate}}</button>
          }
        </fieldset>
      }
      @if (selectedReportType.state === 8) {
        <fieldset [disabled]="!canBeReported(selectedReportType)">
          <h5 class="mb-3">{{'fieldReporting.report.installationDone' | translate}}</h5>
          <div class="d-flex justify-content-start mb-4">
            <button class="btn me-3" style="width: 100px;" (click)="installationDone = true" [ngClass]="installationDone ? 'btn-primary' : 'btn-outline-primary'">{{'basic.yes' | translate}}</button>
            <button class="btn" style="width: 100px;" (click)="installationDone = false" [ngClass]="installationDone ? 'btn-outline-danger' : 'btn-danger'">{{'basic.no' | translate}}</button>
          </div>
          <hr />
          <h5 class="mb-2">{{'basic.comment' | translate}}</h5>
          <textarea
            rows="3"
            class="form-control mb-4"
            [(ngModel)]="comment"
          ></textarea>
          @if (!isStatusReadOnly(selectedReportType)) {
            <app-image-selector (imageSelected)="handleImageUpload($event)"></app-image-selector>
          }
          <div class="d-flex flex-wrap">
            @for (image of images; track $index) {
              <div>
                <img class="thumbnail-img p-1" [src]="image.img" height="100" width="100"
                  (click)="this.currentImg = image; openInModal(content)">
              </div>
            }
          </div>
          @if (!isStatusReadOnly(selectedReportType)) {
            <button class="btn btn-primary w-100" (click)="saveReport()">{{'basic.save' | translate}}</button>
          }
        </fieldset>
      }
      @if (selectedReportType.state === 9) {
        <fieldset [disabled]="!canBeReported(selectedReportType)">
          <h5 class="mb-3">{{'fieldReporting.report.installationDone' | translate}}</h5>
          <div class="d-flex justify-content-start mb-4">
            <button class="btn me-3" style="width: 100px;" (click)="installationDone = true" [ngClass]="installationDone ? 'btn-primary' : 'btn-outline-primary'">{{'basic.yes' | translate}}</button>
            <button class="btn" style="width: 100px;" (click)="installationDone = false" [ngClass]="installationDone ? 'btn-outline-danger' : 'btn-danger'">{{'basic.no' | translate}}</button>
          </div>
          <hr />
          <h5 class="mb-2">{{'basic.comment' | translate}}</h5>
          <textarea
            rows="3"
            class="form-control mb-4"
            [(ngModel)]="comment"
          ></textarea>
          @if (!isStatusReadOnly(selectedReportType)) {
            <app-image-selector (imageSelected)="handleImageUpload($event)"></app-image-selector>
          }
          <div class="d-flex flex-wrap">
            @for (image of images; track $index) {
              <div>
                <img class="thumbnail-img p-1" [src]="image.img" height="100" width="100"
                  (click)="this.currentImg = image; openInModal(content)">
              </div>
            }
          </div>
          @if (!isStatusReadOnly(selectedReportType)) {
            <button class="btn btn-primary w-100" (click)="saveReport()">{{'basic.save' | translate}}</button>
          }
        </fieldset>
      }
      @if (selectedReportType.state === 10) {
        <fieldset [disabled]="!canBeReported(selectedReportType)">
          <h5 class="mb-3">{{'fieldReporting.report.installationDone' | translate}}</h5>
          <div class="d-flex justify-content-start mb-4">
            <button class="btn me-3" style="width: 100px;" (click)="installationDone = true" [ngClass]="installationDone ? 'btn-primary' : 'btn-outline-primary'">{{'basic.yes' | translate}}</button>
            <button class="btn" style="width: 100px;" (click)="installationDone = false" [ngClass]="installationDone ? 'btn-outline-danger' : 'btn-danger'">{{'basic.no' | translate}}</button>
          </div>
          <hr />
          <h5 class="mb-2">{{'basic.comment' | translate}}</h5>
          <textarea
            rows="3"
            class="form-control mb-4"
            [(ngModel)]="comment"
          ></textarea>
          @if (!isStatusReadOnly(selectedReportType)) {
            <app-image-selector (imageSelected)="handleImageUpload($event)"></app-image-selector>
          }
          <div class="d-flex flex-wrap">
            @for (image of images; track $index) {
              <div>
                <img class="thumbnail-img p-1" [src]="image.img" height="100" width="100"
                  (click)="this.currentImg = image; openInModal(content)">
              </div>
            }
          </div>
          @if (!isStatusReadOnly(selectedReportType)) {
            <button class="btn btn-primary w-100" (click)="saveReport()">{{'basic.save' | translate}}</button>
          }
        </fieldset>
      }
      @if (selectedReportType.state === 11) {
        <fieldset [disabled]="!canBeReported(selectedReportType)">
          <h5 class="mb-3">{{'fieldReporting.report.installationDone' | translate}}</h5>
          <div class="d-flex justify-content-start mb-4">
            <button class="btn me-3" style="width: 100px;" (click)="installationDone = true" [ngClass]="installationDone ? 'btn-primary' : 'btn-outline-primary'">{{'basic.yes' | translate}}</button>
            <button class="btn" style="width: 100px;" (click)="installationDone = false" [ngClass]="installationDone ? 'btn-outline-danger' : 'btn-danger'">{{'basic.no' | translate}}</button>
          </div>
          <hr />
          <h5 class="mb-2">{{'basic.comment' | translate}}</h5>
          <textarea
            rows="3"
            class="form-control mb-4"
            [(ngModel)]="comment"
          ></textarea>
          @if (!isStatusReadOnly(selectedReportType)) {
            <app-image-selector (imageSelected)="handleImageUpload($event)"></app-image-selector>
          }
          <div class="d-flex flex-wrap">
            @for (image of images; track $index) {
              <div>
                <img class="thumbnail-img p-1" [src]="image.img" height="100" width="100"
                  (click)="this.currentImg = image; openInModal(content)">
              </div>
            }
          </div>
          @if (!isStatusReadOnly(selectedReportType)) {
            <button class="btn btn-primary w-100" (click)="saveReport()">{{'basic.save' | translate}}</button>
          }
        </fieldset>
      }
      @if (selectedReportType.state === 12) {
        <fieldset>
          @for (remarkReport of remarkReports; track $index) {
            <div>
              @if (remarkReport.show === false) {
                <div class="cursor-pointer" (click)="remarkReport.show = true">
                  <div>{{remarkReport.name}} - {{remarkReport.created | date:'dd.MM.yyyy HH:mm'}}</div>
                </div>
              }
              @if (remarkReport.show === true) {
                <div >
                  <fieldset [disabled]="remarkReport.id !== null">
                    <h5 for="name" class="mb-2">{{'basic.name' | translate}}</h5>
                    <input id="name" type="text" class="form-control" [(ngModel)]="remarkReport.name">
                    <h5 class="mb-2">{{'basic.comment' | translate}}</h5>
                    <textarea
                      rows="3"
                      class="form-control mb-4"
                      [(ngModel)]="remarkReport.notes"
                    ></textarea>
                    @if (!remarkReport.id) {
                      <app-image-selector (imageSelected)="handleImageUploadRemarkReport($event, remarkReport)"></app-image-selector>
                    }
                    <div class="d-flex flex-wrap">
                      @for (image of remarkReport.images; track $index) {
                        <div>
                          <img class="thumbnail-img p-1" [src]="image.img" height="100" width="100"
                            (click)="this.currentImg = image; openInModal(content)">
                        </div>
                      }
                    </div>
                  </fieldset>
                  @if (remarkReport.id !== null) {
                    <button (click)="remarkReport.show = false" class="btn btn-primary">{{'basic.close' | translate}}</button>
                  }
                </div>
              }
              <hr>
              </div>
            }
            <button class="btn btn-primary w-100" (click)="saveRemarkReports()">{{'basic.save' | translate}}</button>
          </fieldset>
        }
        <ng-template #content let-modal>
          <img [src]="currentImg.img" />
          <button class="btn btn-primary" (click)="closeModal()">{{'basic.close' | translate}}</button>
        </ng-template>
      </div>
    }

  </div>
